import { useEffect } from "react";

// Define a type for the callback function
type VisibilityChangeCallback = (isVisible: boolean) => void;

// Define the hook using TypeScript
function usePageVisibility(onVisibilityChange: VisibilityChangeCallback): void {
  useEffect(() => {
    // Handler to call on visibility change
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        onVisibilityChange(true);
      } else {
        onVisibilityChange(false);
      }
    };

    // Add the event listener for 'visibilitychange'
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Clean up the event listener when the component unmounts or re-renders
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [onVisibilityChange]); // Dependency array, re-run effect if callback changes
}

export default usePageVisibility;
